import { handleDownloadOnClick } from "@_common/downloadfile";
import { formatSmallString } from "@_common/format-text";
import { getValue } from "@utils/lodash";
import DownloadNoCircleSvgComponent from "../../assets/svg-components/download-nocircle";
import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { convertCurrentDate } from "@_common/date-helpers";

const DocumentLibraryPopup = (props: any) => {

  return (
    <div>
      <Modal
        isOpen={props.currentDocIsOpen}
        toggle={props.handleCurrentDocPopup}
      >
        <ModalHeader toggle={props.handleCurrentDocPopup}>
          Current Document
        </ModalHeader>
        <ModalBody className="m-0">
          {getValue(props, `currentDoc`, []).length === 0 ? (
            <p>No Current Document</p>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th>Document Name</th>
                  <th>Created At</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>

              <tbody>
                {getValue(props, `currentDoc`, []).map((item: any) => (
                  <tr>
                    <>
                      <td>
                        <p
                          style={{
                            fontSize: "12px",
                            marginTop: "0px",
                          }}
                        >
                          {formatSmallString(item.name)}
                        </p>
                      </td>
                      <td>
                        {convertCurrentDate(getValue(item, `createdAt`, null))}
                      </td>
                      <td
                        onClick={() =>
                          handleDownloadOnClick(item.url, item.name)
                        }
                        className="cursor-pointer"
                      >
                        <DownloadNoCircleSvgComponent size={18} />
                      </td>
                    </>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            className="p-2"
            color="primary"
            onClick={props.handleCurrentDocPopup}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DocumentLibraryPopup;
